module.exports = __webpack_public_path__ + "img/shop_script.592fff5a.png";